import type { ReactNode } from "react";
import { Tooltip } from "./Tooltip";

// Wraps a (typically disabled) control so it explains on hover why it's locked.
// Renders children unwrapped when there's no reason, leaving layout untouched
// while unlocked. The Tooltip's hover target is a wrapper element, so it still
// fires over disabled buttons.
export function IdpLockTooltip({
  reason,
  children,
}: {
  reason: string | null;
  children: ReactNode;
}): ReactNode {
  if (!reason) return children;
  return <Tooltip content={reason}>{children}</Tooltip>;
}
